import { Link, useLocation } from '@tanstack/react-router';

import { DeveloperCredit } from '@/components/developer-credit';
import { landingContent } from '@/constants/landing-content';

const { footer } = landingContent;

export function Footer() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const handleSectionClick = (href: string) => {
    if (isHomePage) {
      const id = href.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = `/${href}`;
    }
  };

  return (
    <footer className="border-border bg-background border-t">
      <div className="container mx-auto max-w-6xl px-4 py-12">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          {/* Logo + Description */}
          <div className="max-w-xs">
            <Link to="/" className="inline-block">
              <img src="/images/logo-text.png" alt="eumimo" className="h-8" />
            </Link>
            <p className="text-muted-foreground text-sm">
              {footer.description}
            </p>
            <p className="text-muted-foreground/60 mt-2 text-xs">
              &copy; {new Date().getFullYear()} eumimo. Todos os direitos
              reservados.
            </p>

            <div className="mt-4">
              <DeveloperCredit />
            </div>
          </div>

          {/* Navigation sections */}
          <div className="flex flex-col gap-8 md:min-w-xl md:flex-row md:justify-between md:gap-16">
            {/* Menu */}
            <div>
              <h3 className="text-foreground font-semibold">
                {footer.menu.title}
              </h3>
              <nav className="mt-4 flex flex-col gap-2">
                {footer.menu.links.map((link) => (
                  <button
                    key={link.href}
                    onClick={() => handleSectionClick(link.href)}
                    className="text-muted-foreground hover:text-foreground w-fit text-sm transition-colors"
                  >
                    {link.label}
                  </button>
                ))}
              </nav>
            </div>

            {/* Social */}
            <div>
              <h3 className="text-foreground font-semibold">
                {footer.social.title}
              </h3>
              <nav className="mt-4 flex flex-col gap-2">
                {footer.social.links.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-muted-foreground hover:text-foreground text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </div>

            {/* Legal */}
            <div>
              <h3 className="text-foreground font-semibold">
                {footer.legal.title}
              </h3>
              <nav className="mt-4 flex flex-col gap-2">
                {footer.legal.links.map((link) => (
                  <Link
                    key={link.href}
                    to={link.href}
                    className="text-muted-foreground hover:text-foreground text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                ))}
              </nav>
              <p className="text-muted-foreground mt-4 text-xs">
                CNPJ: {footer.legal.cnpj}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
